<template>
  <div>
    <Notification :notify="notify" />
    <v-card class="d-flex pa-2 pb-2" outlined tile>
      <div class="row">
        <div class="col-8">
          <b>Publisher:</b> {{ PublisherName }} <b class="ml-10">File:</b>
          {{ FileName }}
        </div>
        <div class="col-4">
          <div class="float-right">
            <v-icon class="mr-2" @click="onRefresh()">mdi-cached</v-icon>
          </div>
        </div>
      </div>
    </v-card>

    <div class="row">
      <div class="col">
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Title</th>
                <th class="text-left">ISBN</th>
                <th class="text-left">Author</th>
                <th class="text-left">Publisher</th>
                <th class="text-left">Year</th>
                <th class="text-left">City</th>
                <th class="text-left">Country</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in listMataData" :key="item.id">
                <td>{{ item.Title }}</td>
                <td>{{ item.ISBN }}</td>
                <td>{{ item.Author }}</td>
                <td>{{ item.Publisher }}</td>
                <td>{{ item.PublishedYear }}</td>
                <td>{{ item.CityOfPublication }}</td>
                <td>{{ item.CountryOfPublication }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <Pagination :paging="paging" v-on:next="onNextPage" />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="float-right">
          <v-btn color="primary" @click="onIngest()" class="mt-4" :loading="loading" :disabled="loading">Ingest</v-btn>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as api from "@/api";
import Notification from "@/components/Notification";
import Pagination from "@/components/Pagination";
import ConfirmationDialog from "@/components/ConfirmationDialog";

export default {
  name: "ReviewPublicationList",
  props: {
    FileId: { type: Number, required: true },
    FileName: { type: String, required: true },
    PublisherName: { type: String, required: true },
    SenderId: { type: Number, required: true },
    step: { type: Number, required: true },
  },
  components: {
    Notification,
    ConfirmationDialog,
    Pagination,
  },
  watch: {
    FileName: function (val) {
      this.FileName = val;
    },
    FileId: function (val) {
      //if (val != "" && val != 0) this.getMetadata(val);
    },
    step: function (val) {
      console.log("val " + val);
      if (val != "" && val != 0 && val == 4){
         this.notify.type = 0;
         this.getMetadata(this.FileId);
      } 
    },
  },
  created() {},
  methods: {
    onRefresh(){
      this.getMetadata(this.FileId);
    },
    getMetadata(FileId) {
      this.listMataData = [];
      new Promise((resolve, reject) => {
        api
          //.getAll("import/onix/metadata/" + fileName)
          .getByPagin(
            "import/onix/metadata/" + FileId + "/review",
            this.paging
          )
          .then((response) => {
            //this.listMataData = response.data;
            this.listMataData = response.data.data;
            this.paging.count = response.data.count;
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    onNextPage(page) {
      this.paging.page = page;
      this.paging.keyword = this.Search;
      this.getMetadata(this.FileId);
    },
    onIngest() {
      console.log(" this.SenderId " + this.SenderId);
      this.listMataData.id = 0;
      new Promise((resolve, reject) => {
        api
          .post(
            "import/onix/process/metadata/" + this.FileId + "/" + this.SenderId,
            this.listMataData
          )
          .then((response) => {
            resolve(response);
            console.log(response.status);
            if (response.status === 200 || response.status === 201) {
              this.notify.type = 1;
              this.notify.message =
                this.id === -1
                  ? "Ingestion has been queued."
                  : "Ingestion has been queued.";
                //this.loading = true;
              this.$emit("onIngest", this.FileId);
            } else {
              this.notify.type = 4;
              this.notify.errors.push("Failed to save data.");
               //this.loading = false;
            }
          })
          .catch((error) => {
            this.notify.type = 4;
            this.notify.errors.push("Failed to save data. " + error);
            reject(error);
          });
      });
    },
  },
  data() {
    return {
      list: [],
      notify: {
        type: 0,
        message: "",
        errors: [],
      },
      paging: { count: 10, page: 1, size: 10, keyword: "" },
      listMataData: [],
      importData: {},
      loading: false,
    };
  },
};
</script>


// WEBPACK FOOTER //
// src/components/ReviewPublicationList.vue